import { render, staticRenderFns } from "./ModalRequestOTP.vue?vue&type=template&id=5b2ac969&"
import script from "./ModalRequestOTP.vue?vue&type=script&lang=js&"
export * from "./ModalRequestOTP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports